import { Box } from '@mui/material';
import { type ReactNode } from 'react';

interface TabPanelProps {
  value: number;
  index: number;
  children?: ReactNode;
}

const TabPanel = ({ children, value, index }: TabPanelProps) => {
  return (
    <div role="tabpanel" hidden={value !== index} id={`tabpanel${index}`}>
      <Box p={2}>{value === index && children}</Box>
    </div>
  );
};

export default TabPanel;
